export const HOST = process.env.REACT_APP_HOST;

export const HL7resourcesAll = [
  'Account',
  'ActivityDefinition',
  'AdverseEvent',
  'AllergyIntolerance',
  'Appointment',
  'AppointmentResponse',
  'AuditEvent',
  'Basic',
  'Binary',
  'BiologicallyDerivedProduct',
  'BodyStructure',
  'Bundle',
  'CapabilityStatement',
  'CarePlan',
  'CareTeam',
  'CatalogEntry',
  'ChargeItem',
  'ChargeItemDefinition',
  'Claim',
  'ClaimResponse',
  'ClinicalImpression',
  'CodeSystem',
  'Communication',
  'CommunicationRequest',
  'CompartmentDefinition',
  'Composition',
  'ConceptMap',
  'Condition',
  'Consent',
  'Contract',
  'Coverage',
  'CoverageEligibilityRequest',
  'CoverageEligibilityResponse',
  'DetectedIssue',
  'Device',
  'DeviceDefinition',
  'DeviceMetric',
  'DeviceRequest',
  'DeviceUseStatement',
  'DiagnosticReport',
  'DocumentManifest',
  'DocumentReference',
  'EffectEvidenceSynthesis',
  'Encounter',
  'Endpoint',
  'EnrollmentRequest',
  'EnrollmentResponse',
  'EpisodeOfCare',
  'EventDefinition',
  'Evidence',
  'EvidenceVariable',
  'ExampleScenario',
  'ExplanationOfBenefit',
  'FamilyMemberHistory',
  'Flag',
  'Goal',
  'GraphDefinition',
  'Group',
  'GuidanceResponse',
  'HealthcareService',
  'ImagingStudy',
  'Immunization',
  'ImmunizationEvaluation',
  'ImmunizationRecommendation',
  'ImplementationGuide',
  'InsurancePlan',
  'Invoice',
  'Library',
  'Linkage',
  'List',
  'Location',
  'Measure',
  'MeasureReport',
  'Media',
  'Medication',
  'MedicationAdministration',
  'MedicationDispense',
  'MedicationKnowledge',
  'MedicationRequest',
  'MedicationStatement',
  'MedicinalProduct',
  'MedicinalProductAuthorization',
  'MedicinalProductContraindication',
  'MedicinalProductIndication',
  'MedicinalProductIngredient',
  'MedicinalProductInteraction',
  'MedicinalProductManufactured',
  'MedicinalProductPackaged',
  'MedicinalProductPharmaceutical',
  'MedicinalProductUndesirableEffect',
  'MessageDefinition',
  'MessageHeader',
  'MolecularSequence',
  'NamingSystem',
  'NutritionOrder',
  'Observation',
  'ObservationDefinition',
  'OperationDefinition',
  'OperationOutcome',
  'Organization',
  'OrganizationAffiliation',
  'Parameters',
  'Patient',
  'PaymentNotice',
  'PaymentReconciliation',
  'Person',
  'PlanDefinition',
  'Practitioner',
  'PractitionerRole',
  'Procedure',
  'Provenance',
  'Questionnaire',
  'QuestionnaireResponse',
  'RelatedPerson',
  'RequestGroup',
  'ResearchDefinition',
  'ResearchElementDefinition',
  'ResearchStudy',
  'ResearchSubject',
  'RiskAssessment',
  'RiskEvidenceSynthesis',
  'Schedule',
  'SearchParameter',
  'ServiceRequest',
  'Slot',
  'Specimen',
  'SpecimenDefinition',
  'StructureDefinition',
  'StructureMap',
  'Subscription',
  'Substance',
  'SubstancePolymer',
  'SubstanceProtein',
  'SubstanceReferenceInformation',
  'SubstanceSpecification',
  'SubstanceSourceMaterial',
  'SupplyDelivery',
  'SupplyRequest',
  'Task',
  'TerminologyCapabilities',
  'TestReport',
  'TestScript',
  'ValueSet',
  'VerificationResult',
  'VisionPrescription',
];

// TODO save in DB and generate base on template
export const resourceList = [
  {
    resourceName: 'Patient',
    type: 'Patient Access',
    HL7: 'https://hl7.org/fhir/us/carin-bb/StructureDefinition/C4BB-Patient',
    resourcetype: 'Patient',
    namespace: '',
    ig: 'CARIN-BB',
  },
  {
    resourceName: 'Coverage',
    type: 'Patient Access',
    HL7: 'https://hl7.org/fhir/us/carin-bb/StructureDefinition/C4BB-Coverage',
    resourcetype: 'Coverage',
    namespace: '',
    ig: 'CARIN-BB',
  },
  {
    resourceName: 'Care Plan',
    type: 'Patient Access',
    HL7: 'https://hl7.org/fhir/us/core/STU3.1.1/StructureDefinition-us-core-careplan.html',
    resourcetype: 'CarePlan',
    namespace: '',
    ig: 'US Core',
  },
  {
    resourceName: 'Explanation Of Benefit Institutional',
    type: 'Patient Access',
    HL7: [
      'https://hl7.org/fhir/us/carin-bb/STU1/StructureDefinition-C4BB-ExplanationOfBenefit-Inpatient-Institutional.html',
      'https://hl7.org/fhir/us/carin-bb/STU1/StructureDefinition-C4BB-ExplanationOfBenefit-Outpatient-Institutional.html',
    ],
    resourcetype: 'ExplanationOfBenefit',
    namespace: 'EOBInstitutional',
    ig: 'CARIN-BB',
  },
  {
    resourceName: 'Explanation Of Benefit Pharmacy',
    type: 'Patient Access',
    HL7: '',
    resourcetype: 'ExplanationOfBenefit',
    namespace: 'EOBPharmacy',
    ig: 'CARIN-BB',
  },
  {
    resourceName: 'Explanation Of Benefit Professional',
    type: 'Patient Access',
    HL7: 'https://hl7.org/fhir/us/carin-bb/STU1/StructureDefinition-C4BB-ExplanationOfBenefit-Professional-NonClinician.html',
    resourcetype: 'ExplanationOfBenefit',
    namespace: 'EOBProfessional',
    ig: 'CARIN-BB',
  },
  {
    resourceName: 'Condition',
    type: 'Patient Access',
    HL7: 'https://www.hl7.org/fhir/clinicalsummary-module.html',
    resourcetype: 'Condition',
    namespace: '',
    ig: 'R4',
  },
  {
    resourceName: 'Observation',
    type: 'Patient Access',
    HL7: 'https://www.hl7.org/fhir/observation.html',
    resourcetype: 'Observation',
    namespace: '',
    ig: 'R4',
  },
  {
    resourceName: 'Goal',
    type: 'Patient Access',
    HL7: 'https://hl7.org/fhir/us/core/STU3.1.1/StructureDefinition-us-core-goal.html',
    resourcetype: 'Goal',
    namespace: '',
    ig: 'US Core',
  },
  {
    resourceName: 'Allergy Intolerance',
    type: 'Patient Access',
    HL7: 'https://hl7.org/fhir/us/core/STU3.1.1/StructureDefinition-us-core-allergyintolerance.html',
    resourcetype: 'AllergyIntolerance',
    namespace: '',
    ig: 'US Core',
  },
  {
    resourceName: 'Organization',
    type: 'Provider Directory',
    HL7: 'https://hl7.org/fhir/us/carin-bb/STU1/StructureDefinition-C4BB-Organization.html',
    resourcetype: 'Organization',
    namespace: '',
    ig: 'CARIN-BB',
  },
  {
    resourceName: 'Diagnostic Report',
    type: 'Provider Directory',
    HL7: 'https://hl7.org/fhir/R4/diagnosticreport.html',
    resourcetype: 'DiagnosticReport',
    namespace: '',
    ig: 'R4',
  },
  {
    resourceName: 'Encounter',
    type: 'Provider Directory',
    HL7: 'https://hl7.org/fhir/encounter.html',
    resourcetype: 'Encounter',
    namespace: '',
    ig: 'R4',
  },
  {
    resourceName: 'Practitioner',
    type: 'Provider Directory',
    HL7: 'https://hl7.org/fhir/us/carin-bb/STU1/StructureDefinition-C4BB-Practitioner.html',
    resourcetype: 'Practitioner',
    namespace: '',
    ig: 'CARIN-BB',
  },
  {
    resourceName: 'Practitioner Role',
    type: 'Provider Directory',
    HL7: 'https://www.hl7.org/fhir/practitionerrole.html',
    resourcetype: 'PractitionerRole',
    namespace: '',
    ig: 'R4',
  },
  {
    resourceName: 'Location',
    type: 'Provider Directory',
    HL7: 'https://hl7.org/fhir/us/davinci-pdex-plan-net/STU1/StructureDefinition-plannet-Location.html',
    resourcetype: 'Location',
    namespace: '',
    ig: 'DaVinci PDex',
  },
  {
    resourceName: 'Medication Knowledge',
    type: 'Formulary',
    HL7: 'https://hl7.org/fhir/medicationknowledge.html',
    resourcetype: 'MedicationKnowledge',
    namespace: '',
    ig: 'R4',
  },
  {
    resourceName: 'Coverage Plan',
    type: 'Formulary',
    HL7: 'https://hl7.org/fhir/us/davinci-drug-formulary/STU1.0.1/StructureDefinition-usdf-CoveragePlan.html',
    resourcetype: 'List',
    namespace: '',
    ig: 'DaVinci PDex',
  },
];

export const PLACEHOLDER_SAMPLE_DATA = {
  member_id: '0123456789',
  unique_member_id: 'ABCDE123',
  medicare_id: null,
  family_name: 'WICK',
  given_name: 'JOHN',
  phone_no: '200-300-4560',
  gender: 'Male',
  birth_dt: '11/22/1900 00:00:00.',
  deceased_dt: '01/01/1753',
  deceased_flg: 'X',
  address_line_1: '123 MAIN ST',
  city: 'NEW YORK CITY',
  state: 'NY',
  zipcode: '00011',
  member_language: 'English',
  race: 'White/Caucasian',
  ethnicity: null,
};

export const USER_ROLE = window.localStorage.getItem('user_role');

export const JSON_VIEW = 'useJSONView';
export const FLATTENED_VIEW = 'useFlattenedView';
export const NARRATIVE_VIEW = 'useNarrativeView';
export const MAPPING_VIEW = 'useMappingView';
export const TREE_VIEW = 'useTreeView';
export const REFERENCE_VIEW = 'useReferenceView';

export const EXTENSION = ['extension[#].url', 'extension[#].value'];

export const EXTENSION_CODEABLE_CONCEPT = [
  'extension[#].valueCodeableConcept.text',
  'extension[#].url',
  'extension[#].valueCodeableConcept.coding[0].code',
  'extension[#].valueCodeableConcept.coding[0].system',
  'extension[#].valueCodeableConcept.coding[0].display',
];

export const CODEABLE_CONCEPT = ['coding[#].code', 'coding[#].system', 'coding[#].display'];

export const FHIR_TABLE_CELL_HEIGHT = 50;

export const MAPPING_ASSISTANT_TOOLTIP = (
  <>The Mapping Assistant allows you to search for values that may be used in the mapping.</>
);

export const TABLE_TOOLTIP_VALUE = (
  <>
    The value to render at the <code className="light-code">path</code> location. Values may be
    hard-coded strings, digits, or evaluated from an input JSON object accessed via underscore.
    Groovy functions may also be invoked to perform additional transformations. Groovy may also be
    written in-line. <br />
    <br /> Examples: <br />
    1) <code className="light-code">"completed"</code> <br />
    2) <code className="light-code">_.column</code> <br />
    3) <code className="light-code">_.column == "Y" ? true : false</code> <br />
    4) <code className="light-code">GetStatus(_.column)</code>
    <br />
    <br />
    Note: If any values in this column are not valid Groovy, then no transformations will work for
    any mappings as JSONtoFHIR lambda compilation will fail.
  </>
);

export const TABLE_TOOLTIP_FLAG = (
  <>Flags indicate issues that need to be addressed.</>
);

export const TABLE_TOOLTIP_PATH = (
  <>An individual key within a FHIR resource expressed in JSON dot notation like syntax.</>
);

export const TABLE_TOOLTIP_DRIVING = (
  <>
    Indicates whether the path specified should be removed if the rendered value evaluates to{' '}
    <code className="light-code">null</code>. Accepted values: <br />
    <br />
    <code className="light-code">self</code>: the current value should be removed.
    <br />
    <code className="light-code">parent</code>: the current and enclosing parent value should be
    removed.
    <br />
    <code className="light-code">parent:2</code>: the current, parent, and grandparent element
    should be removed. <br />
    <code className="light-code">parent:3</code>: the current, parent, grandparent, and
    great-grandparent element should be removed.
  </>
);

export const FILE_SCHEMA_TOOLTIP = (
  <>
    Descriptive name for the file from which the mappings originate. Please make this as general as
    possible. For instance, instead of naming it{' '}
    <code className="light-code">us_core_vitals_panel_file_052016_05192021</code>, name it{' '}
    <code className="light-code">US Core Vitals Panel</code> instead.
  </>
);

export const QA_VIEW_SELECT = 'QAViewWrapperSelection';

function toString(row, fieldName) {
  const replacer = (key, value) => (value === null ? '' : value);

  if (fieldName !== 'value') {
    return JSON.stringify(row[fieldName], replacer);
  }

  if (row[fieldName] === null) {
    return '';
  }

  if (row[fieldName].startsWith('"') && row[fieldName].endsWith('"')) {
    return `""${row[fieldName]}""`;
  }

  return JSON.stringify(row[fieldName], replacer);
}

export function JSONtoCSV(jsonArr) {
  if (!!jsonArr === false) return;
  const header = Object.keys(jsonArr[0]);
  return [
    header.join(','), // header row first
    ...jsonArr.map(row => header.map(fieldName => toString(row, fieldName)).join(',')),
  ].join('\r\n');
}

export const segment = '@segment:';

export const nodeColors = [
  '#87EAFE',
  '#DD92FC',
  '#9297FC',
  '#87FE8A',
  '#DAFE87',
  '#FEE387',
  '#FECB87',
  '#FE9C87',
  '#DD92FC',
  '#FF88FB',
  '#88BDFF',
  '#88FFF7',
  '#88FFD6',
  '#88FFAE',
  '#D5FB20',
  '#F9C87E',
  '#F9A0A0',
  '#CCF9A0',
  '#F9CCA0',
  '#A0F9CC',
  '#B4B4B4',
];

export const statusToColorMap = {
  Failed: {
    color: '#cf1322',
    border: '#ffa39e',
    background: '#fff1f0',
  },
  Processing: {
    color: '#d46b08',
    border: '#ffd591',
    background: 'fff7e6',
  },
  Partial: {
    color: '#096dd9',
    border: '#91d5ff',
    background: '#e6f7ff',
  },
  Succeeded: {
    color: '#389e0d',
    border: '#b7eb8f',
    background: '#f6ffed',
  },
};